@import "../../../../css/_mixins.scss";

.customContent {
  padding: 28px 40px;
  background-color: var(--red);

  @include small-desktop {
    padding: 24px 32px;
  }

  @include mobile {
    padding: 24px 16px;
  }
}

.container {
  display: flex;
  position: relative;
  z-index: 1;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  height: 72px;
  background-color: var(--red);
  padding: 0 40px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

  @include small-desktop {
    padding: 0 32px;
  }
  @media (max-width: 700px) {
    padding: 0 12px;
    gap: 12px;
  }

  .inputRedeemCode {
    width: 230px;
    height: 40px;
    padding: 0 16px;
    text-align: center;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: var(--gray);
    background-color: #fff;
    border: none;
    border-radius: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    text-transform: uppercase;
    box-sizing: border-box;

    &::placeholder {
      color: #b5b5b5;
      font-weight: 500;
      letter-spacing: 0;
      text-transform: none;
    }

    &:focus {
      outline: 2px solid var(--yellow);
      outline-offset: 1px;
    }

    @media screen and (max-width: 1080px) {
      height: 38px;
      max-width: 45%;
      font-size: 14px;
    }
  }

  .leftContent {
    display: flex;
    align-items: center;
    gap: 16px;

    @include small-desktop {
      display: none;
    }

    .mainMenu {
      margin-right: 8px;
    }

    .linkLogin {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 6px 12px;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      text-decoration: none;
      border-radius: 6px;
      cursor: pointer;
      transition: background-color 0.15s ease, color 0.15s ease;

      i {
        font-size: 18px;
        line-height: 1;
      }

      &:hover,
      &:focus {
        background-color: rgba(255, 255, 255, 0.12);
        color: #fff !important;
        text-decoration: none;
      }
    }

    .linkCart {
      position: relative;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 6px 12px;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      text-decoration: none;
      border-radius: 6px;
      cursor: pointer;
      transition: background-color 0.15s ease;

      i {
        font-size: 18px;
        line-height: 1;
        margin: 0;
      }

      .cartBadge {
        position: absolute;
        top: -2px;
        left: 22px;
        min-width: 18px;
        height: 18px;
        padding: 0 5px;
        color: var(--red);
        background-color: var(--yellow);
        border-radius: 9px;
        font-size: 11px;
        font-weight: 700;
        line-height: 18px;
        text-align: center;
        box-shadow: 0 0 0 2px var(--red);
      }

      &:hover,
      &:focus {
        background-color: rgba(255, 255, 255, 0.12);
        color: #fff !important;
        text-decoration: none;
      }
    }
  }

  .rightContent {
    display: flex;
    align-items: center;
    gap: 20px;

    @include small-desktop {
      justify-content: space-between;
      width: 100%;
    }

    .redeemContent {
      display: flex;
      align-items: center;
      gap: 12px;

      @include mobile {
        width: 100%;
      }

      .btnRedeemContent {
        position: relative;
        display: flex;
        align-items: center;
        height: 40px;
        text-align: center;
        color: white;

        .btnRedeem {
          height: 40px;
          padding: 0 18px;
          background-color: transparent;
          border: 2px solid rgba(255, 255, 255, 0.85);
          border-radius: 20px;
          color: #fff;
          font-size: 15px;
          font-weight: 700;
          white-space: nowrap;
          cursor: pointer;
          transition: background-color 0.15s ease, color 0.15s ease;

          &:hover {
            background-color: #fff;
            color: var(--red) !important;
          }
          &:active {
            transform: translateY(1px);
          }

          @include small-desktop {
            font-size: 14px;
          }

          @include mobile {
            width: 100%;
            height: 44px;
            font-size: 14px;
          }
        }

        .linkMultiRedeem {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          margin-top: 2px;
          font-size: 11px;
          font-weight: 600;
          color: rgba(255, 255, 255, 0.85);
          text-decoration: none;
          letter-spacing: 0.2px;
          white-space: nowrap;

          &:hover {
            color: #fff !important;
            text-decoration: underline;
          }

          @include mobile {
            display: none;
          }
        }
      }
    }

    .btnGiveGift {
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      padding: 0 22px;
      font-size: 15px;
      font-weight: 700;
      letter-spacing: 0.2px;
      border-radius: 20px;
      background-color: var(--yellow);
      border: 2px solid var(--yellow);
      color: var(--red);
      text-decoration: none;
      white-space: nowrap;
      transition: filter 0.15s ease, transform 0.05s ease;

      &:hover {
        filter: brightness(1.05);
        color: var(--red) !important;
        text-decoration: none;
      }
      &:active {
        transform: translateY(1px);
      }

      @media (max-width: 900px) {
        height: 36px;
        padding: 0 14px;
        font-size: 13px;
      }

      @include mobile {
        display: none;
      }
    }
  }

  .barTitle {
    flex: 1;
    text-align: center;
    font-weight: 700;
    font-size: 22px;
    color: var(--white);
    letter-spacing: 0.02rem;

    @include small-desktop {
      display: none;
    }
  }
}
